import { render, staticRenderFns } from "./snippet_description_view.vue.js?vue&type=template&id=421b9fc8&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./snippet_description_view.vue?vue&type=template&id=421b9fc8&vue3"
import script from "./snippet_description_view.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./snippet_description_view.vue?vue&type=script&lang=js&vue3"
export * from "./snippet_description_view.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./snippet_description_view.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports